module.exports = __webpack_public_path__ + "img/default_avatar_male.cec429d1.png";